var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.projects.length)?_vm._l((_vm.projects),function(project){return _c('projects-card',{key:project.uuid,attrs:{"project":project}})}):_c('span',[_vm._v("Geen recente projecten gevonden")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }